var Parser = require('./lib/parser')
var Stringifier = require('./lib/stringifier')

exports.parse = function parse (options) {
  return new Parser(options)
}

exports.stringify = function stringify () {
  return new Stringifier()
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/jsonlines/index.js
// module id = 575
// module chunks = 0